import fetchFactoringProfile from './fetchFactoringProfile';

const updateReportVisibility = (factoringId, reportVisibility) => async (
  dispatch,
  getState,
  { api }
) => {
  const response = await api.factoring.updateReportVisibility(
    factoringId,
    reportVisibility
  );
  await dispatch(fetchFactoringProfile(factoringId));
  return response;
};

export default updateReportVisibility;
